import { render, staticRenderFns } from "./SurveyModal.vue?vue&type=template&id=478f9fb2&scoped=true"
import script from "./SurveyModal.vue?vue&type=script&lang=js"
export * from "./SurveyModal.vue?vue&type=script&lang=js"
import style0 from "./SurveyModal.vue?vue&type=style&index=0&id=478f9fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f9fb2",
  null
  
)

export default component.exports